import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import { useUser } from '../../hooks/useUser';

export enum AuthModalScreen {
	LOGIN = 'login',
	SIGNUP = 'signup',
	FORGOT_PASSWORD = 'forgot-password',
}

interface AuthModalProps {
	defaultScreen: AuthModalScreen.LOGIN | AuthModalScreen.SIGNUP;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

function AuthModal({ defaultScreen = AuthModalScreen.LOGIN, isOpen, onClose, onSuccess }: AuthModalProps) {
	const { data, isSuccess } = useUser();
	const [currentScreen, setCurrentScreen] = React.useState<AuthModalScreen>(defaultScreen || AuthModalScreen.LOGIN);
	useEffect(() => {
		if (isOpen && isSuccess && data) {
			onSuccess && onSuccess();
			onClose();
		}
	}, [data, isOpen, isSuccess, onClose, onSuccess]);
	return (
		<Modal
			isCentered
			isOpen={isOpen}
			onClose={() => {
				onClose();
			}}
		>
			<ModalOverlay />
			<ModalCloseButton />

			<ModalContent>
				<ModalHeader>
					{currentScreen === AuthModalScreen.LOGIN ? 'Sign In' : currentScreen === AuthModalScreen.SIGNUP ? 'Sign Up' : 'Forgot Password'}
				</ModalHeader>
				<ModalBody pb={8}>
					{currentScreen === AuthModalScreen.LOGIN ? (
						<SignInForm
							onSignUpClick={() => setCurrentScreen(AuthModalScreen.SIGNUP)}
							onForgotPasswordClick={() => setCurrentScreen(AuthModalScreen.FORGOT_PASSWORD)}
						/>
					) : currentScreen === AuthModalScreen.SIGNUP ? (
						<SignUpForm onSignInClick={() => setCurrentScreen(AuthModalScreen.LOGIN)} />
					) : (
						<ForgotPasswordForm onSignInClick={() => setCurrentScreen(AuthModalScreen.LOGIN)} />
					)}
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default AuthModal;
